import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Activity, Eye, EyeOff } from 'lucide-react';
import { EditorSection } from '~/components/promotion/editor-section';
import { ToggleRow } from '~/components/toggle-row';
import type { PromotionFormValues } from '~/lib/schemas/promotion';

/**
 * Constraint #5: `isVisible` (iv) and `hideFromOffers` (HideFromOffers) are TWO
 * independent backend flags (shouldList = isVisible && !hideFromOffers) — kept as
 * two separate toggles, not consolidated.
 */
export function StatusVisibilitySection() {
	const { t } = useTranslation();
	const { control } = useFormContext<PromotionFormValues>();

	return (
		<EditorSection title={t('promotion.basicInfo.statusVisibility.title')} subtitle={t('promotion.basicInfo.statusVisibility.subtitle')}>
			<div className="flex flex-col gap-2">
				<Controller
					control={control}
					name="isActive"
					render={({ field }) => (
						<ToggleRow
							label={t('promotion.basicInfo.statusVisibility.active')}
							help={t('promotion.basicInfo.statusVisibility.activeHelp')}
							icon={Activity}
							checked={field.value}
							onCheckedChange={field.onChange}
						/>
					)}
				/>
				<Controller
					control={control}
					name="isVisible"
					render={({ field }) => (
						<ToggleRow
							label={t('promotion.basicInfo.statusVisibility.visible')}
							help={t('promotion.basicInfo.statusVisibility.visibleHelp')}
							icon={Eye}
							checked={field.value}
							onCheckedChange={field.onChange}
						/>
					)}
				/>
				<Controller
					control={control}
					name="hideFromOffers"
					render={({ field }) => (
						<ToggleRow
							label={t('promotion.basicInfo.statusVisibility.hidden')}
							help={t('promotion.basicInfo.statusVisibility.hiddenHelp')}
							icon={EyeOff}
							checked={field.value}
							onCheckedChange={field.onChange}
						/>
					)}
				/>
			</div>
		</EditorSection>
	);
}
